import { RaiseText } from "../raise-components"
import React from "react"

import { Button, Text } from "@atos6/ui"
import { Card } from "../App.styles"
import { ButtonCopyClipboard } from "../components"
import { useStore } from "../containers"
import { CSS } from "../ui"

export function DonateLinkCell() {
  const { publicOnlineDonationUrl, isAccountCreated } = useStore()

  return (
    <Card disabled={!isAccountCreated}>
      <RaiseText
        fontSize="20px"
        fontWeight="600"
        textAlign="center"
        marginBottom="30px">
        Link de doação
      </RaiseText>
      <CSS display="flex" flexWrap="wrap" alignItems="center">
        <CSS as={Text}>{publicOnlineDonationUrl}</CSS>
        <CSS display="flex" flexGrow={1}>
          <div style={{ flexGrow: 1 }} />
          <ButtonCopyClipboard value={publicOnlineDonationUrl} />
          <CSS width={10} />
          <Button target="_blank" href={publicOnlineDonationUrl} type="primary">
            Ver página
          </Button>
        </CSS>
      </CSS>
    </Card>
  )
}
